import { z } from 'zod';

import { idSchema } from './id';
import { skillShortSchema } from './skill';

import type { Mutation } from './common';

type SkillIdsField = {
    readonly skillIds: readonly string[];
};

export const publicationHistoryItemSchema = z.object({
    id: z.uuid(),
    date: z.string().optional(),
    description: z.string().optional(),
    publicationName: z.string(),
    publisher: z.string().optional(),
    skills: skillShortSchema.array().optional(),
});

export const publicationHistoryItemArraySchema = publicationHistoryItemSchema.array();

export type PublicationHistoryItem = z.infer<typeof publicationHistoryItemSchema>;

export const publicationHistoryCreationSchema = publicationHistoryItemSchema
    .omit({ id: true, skills: true })
    .extend({ skillIds: idSchema.array().optional() });
export type PublicationHistoryCreation = z.infer<typeof publicationHistoryCreationSchema>;

export type PublicationHistoryMutation = Mutation<PublicationHistoryItem> &
    Pick<PublicationHistoryItem, 'id' | 'publicationName'> &
    SkillIdsField;
